import axios, { type AxiosError } from "axios";

import { GeneralError } from "./types/GeneralError";
import { NoConnectionError } from "./types/NoConnectionError";
import { NotAuthenticatedError } from "./types/NotAuthenticatedError";
import { type APIError, ServerError } from "./types/ServerError";
import { UnauthorizedError } from "./types/UnauthorizedError";

// TODO: Remove me
const isApiServerError = (error: unknown): error is APIError =>
  typeof error === "object" &&
  error !== null &&
  "errors" in error &&
  Array.isArray(error.errors);

export const getErrorProps = (error: Error | AxiosError<APIError>) => {
  const isAxiosError = axios.isAxiosError(error);
  const statusCode = isAxiosError ? error.response?.status : undefined;

  if (isAxiosError && !error.response) {
    return new NoConnectionError();
  }

  const errorByStatusCode = statusCode
    ? getErrorByStatusCode(statusCode)
    : null;

  if (errorByStatusCode) {
    return errorByStatusCode;
  }

  if (isAxiosError && isApiServerError(error.response?.data)) {
    return new ServerError(error.response?.data);
  }

  return new GeneralError(
    "message" in error ? error.message : undefined,
    "stack" in error ? error.stack : undefined
  );
};

const getErrorByStatusCode = (statusCode: number) => {
  switch (statusCode) {
    case 401:
      return new NotAuthenticatedError();
    case 403:
      return new UnauthorizedError();
    case 408:
    case 500:
    case 503:
    case 522:
    case 523:
    case 524:
    case 599:
      return new NoConnectionError();
    default:
      return null;
  }
};
